/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

interface ITransactionDetails {
  transactionId: string;
  dateScheduled: string;
  datePaid: string;
  dateProcessed: string;
  from: string;
  to: string;
  status: string;
  month: string;
  amount: any;
  propertyName: string;
  accountPaidTo: string;
  id: number;
}

interface TransactionState {
  transactionDetails: ITransactionDetails | null;
}

const initialState: TransactionState = {
  transactionDetails: null
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setTransactionDetails: (state, action) => {
      state.transactionDetails = action.payload;
    }
  }
});

export const { setTransactionDetails } = transactionSlice.actions;
export default transactionSlice.reducer;
